import { Outlet, useLocation } from "react-router-dom"
import Footer from "../footer/Footer"
import Header from "../header/Header"
import { motion } from "motion/react"
import { useEffect, useState } from "react";
import axios from "axios";
import { AuthContext } from "./AuthContext";

const Layout = ({id}) => {

	const location = useLocation()

const isDoctorsPage = location.pathname === '/doctors' || `/doctors/${id}`
	 const containerClasses = `
     ${'bg-[#f2f2f2]'}
    ${isDoctorsPage ? 'sm:px-[6%]' : ''}
    transition-all duration-500
  `;
  const [userInfo, setUserInfo] = useState({name:null,isLoggedIn:null})
  
  const [loading, setLoading] = useState(true)

  const [isLogged, setIslogged] = useState(null)

  useEffect(()=>{
	axios.get('https://medizen.ir/checkAccess.php')
	.then(response=>{
		const data = response.data
		console.log(data);
		
		if(data.is_logged){
			setUserInfo({name:data.name, isLoggedIn:true})
			setIslogged(true)
		}else{
			setUserInfo({isLoggedIn:false})
			setIslogged(false)
		}
	}).catch(error=>{
		console.log('مشکلی پیش امده',error)
		setUserInfo({isLoggedIn:false})
		setIslogged(false);
	}).finally(()=>setLoading(false))
  },[])

//   if(loading) return <div className="bg-red-500">در جال بررسی</div>
	return (
	<AuthContext.Provider value={{ isLogged, userInfo, loading }}>
		<div className={`font-kalameh min-h-screen
			text-[16px] bg-[#FCFCFC] text-[#444444] `}
			dir="rtl">
			<div className={` ${containerClasses} `}>
				<div className="w-full flex justify-center">
					<div className="w-[90%] sm:w-full">
								<Header
								userName={userInfo.name?userInfo.name:'ورود'}
								/>

						<motion.div
						key={location.pathname}
						initial={{opacity:0}}
						animate={{opacity:1}}
						exit={{opacity:0}}
						transition={{duration:0.5}}
						>
						<Outlet />
						</motion.div>
					</div>
				</div>
			</div>
            <Footer/>
		</div>
	</AuthContext.Provider>
	);
};
export default Layout;